'use strict';
import Barba from 'barba.js'
import Env from '../base/env.js'
import Channels from '../base/channels'
import Mailto from '../components/Mailto'
import Emoji from '../components/contact/Emoji'
import 'babel-polyfill'

let page

class Page
{
    constructor(view='')
    {
        this.view = view
        this.classView = 'currentView--contact'
        // Fns
        new Mailto(this.view)
        this.emoji = new Emoji(this.view)
        this.emoji.setup()
        this.emoji.start()
        // Launch Fn
        this.funcLaunch = this.intro.bind(this)
        if(Env.framework.UI.launcher.LAUNCHED == false) this.channels()
    }

    channels()
    {
        Channels.on('launcher::exit',this.funcLaunch)
    }

    destroy()
    {
        Channels.removeListener('launcher::exit', this.funcLaunch);
    }

    exit()
    {
        this.emoji.stop()
        this.emoji.destroy()
    }

    finalize()
    {
        setTimeout(() => {
            if(Env.isVisiting === true) {
                this.intro()
            }
        }, 100);
    }

    intro()
    {
        let timeline = new TimelineLite()
        const $fill = this.view.querySelector('.fxFill')
        const $desc = this.view.querySelector('.fxDesc')
        const $button = this.view.querySelector('.fxButton')
        const $social = this.view.querySelector('.fxSocial')
        const $canvas = this.view.querySelector('.fxCanvas')

        timeline.add([
            TweenLite.fromTo($fill , 1 , { scaleX : 0 } , { scaleX : 1 , ease : Power3.easeInOut }),
            TweenLite.fromTo($desc , 1 , { opacity : 0 , y : 30 } , { opacity : 1 , y : 0 , delay : .5 , ease : Power3.easeOut }),
            TweenLite.fromTo($button , 1 , { opacity : 0 , y : 30 } , { opacity : 1 , y : 0 , delay : .6 , ease : Power3.easeOut }),
            TweenLite.fromTo($social , 1 , { opacity : 0 , y : 30 } , { opacity : 1 , y : 0 , delay : .7 , ease : Power3.easeOut }),
            TweenLite.fromTo($canvas , 1 , { opacity : 0 } , { opacity : .6 , delay : .8 , ease : Cubic.easeOut }),
        ])
        timeline.add(()=>{
            $button.classList.remove('fxButton')
            TweenLite.set($button , { clearProps : 'all' })
        })
    }


}

page = Barba.BaseView.extend({
    namespace: 'contact',
    node: undefined,
    onEnter: function() {
        this.node = new Page(this.container)
        Env.$html.classList.add(this.node.classView)
    },
    onLeave: function() {
        this.node.destroy()
    },
    onEnterCompleted:function() {
        this.node.finalize()
    },
    onLeaveCompleted: function()
    {
        this.node.exit()
        if(this.container.getAttribute('data-namespace') != this.namespace)
        {
            Env.$html.classList.remove(this.node.classView)
        }
    }
});

export default page;